module.exports = __webpack_public_path__ + "svg/logo-bbr-white.svg";